<template>
  <div>
    <v-toolbar color="grey lighten-2" absolute flat height="22em" tabs>
      <template slot="extension">
        <v-tabs v-model="currentTab" centered flat icons-and-text class="pb-4" color="grey lighten-2">
           <v-tab href="#tab-1" to="/selector/todos" >
            <span>Todos</span>
            <v-icon>fa-futbol</v-icon>
          </v-tab>
          <v-tab href="#tab-2" to="/selector/primera/1">
            <span>Primera</span>
            <v-icon>fa-futbol</v-icon>
          </v-tab>
          <v-tab href="#tab-3" to="/selector/proyeccion/2">
            <span>Proyección</span>
            <v-icon>fa-futbol</v-icon>
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <div class="top-spacing">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

export default {

  data () {
    return {
      currentTab: null,
      tabs: [
        { id: 1, componentName: 'Todos' },
        { id: 2, componentName: 'Primera' },
        { id: 3, componentName: 'Reserva' }
      ]
    }
  }
}
</script>

<style scoped>
.top-spacing {
  margin-top: 5em;
}
</style>
